import React, { useState } from "react";
import PropTypes from "prop-types";

// Label Component
const Label = ({ htmlFor, children, required }) => (
  <label htmlFor={htmlFor} className="form-label w-100 fs-5 inmate-label" >
    {children} {required && <span className="text-danger">*</span>}
  </label>
);

const PasswordField = ({
  name,
  id,
  label,
  value,
  onChange,
  onBlur,
  errorMessage,
  placeholder,
  required,
  disabled = false,
  maxLength =50,
  onKeyDown,
  showPassword,
  setShowPassword, // Lifted state from parent
}) => {
  //const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div>
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      <div className="position-relative">
        <input
          type={showPassword ? "text" : "password"}
          name={name}
          id={id} // Ensure this matches the label's htmlFor
          className={`form-control mb-3 fs-5 ${errorMessage ? "border-danger" : ""} fw-normal`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          required={false}
          disabled={disabled}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
        />
        <button
          type="button"
          className="btn btn-light position-absolute end-0 top-50 translate-middle-y p-0 border-0 bg-transparent me-3"
          onClick={togglePasswordVisibility}
          aria-label="Toggle password visibility"
          style={{ zIndex: 10 }}
        >
          <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"} text-dark`}></i>
        </button>
      </div>
      {errorMessage && (
        <div className="text-danger fw-700 fs-6 mt-1">
          {errorMessage}
        </div>
      )}
    </div>
  );
};

PasswordField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired, // Make this required to ensure it's passed
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  errorMessage: PropTypes.string, // Accepts a string for error messages
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

PasswordField.defaultProps = {
  placeholder: "",
  required: false,
  disabled: false,
  errorMessage: "",
};

export default PasswordField;
